import { Grid } from "@mantine/core";
import CardExample from "./Card";
import { Accordion, Text, LoadingOverlay } from "@mantine/core";
import { useEffect, useState } from "react";
import { getAdminTasks, getMenteeTasks } from "../../api/tasks";
import { showNotification } from "@mantine/notifications";
const type = localStorage.getItem("type");

interface AccordionLabelProps {
  label: string;
}

function AccordionLabel({ label }: AccordionLabelProps) {
  return <Text align="center">{label}</Text>;
}

async function getAdminTasksF() {
  const res = await getAdminTasks().catch((err) => {
    showNotification({
      title: "ERROR",
      message:
        err.response != null
          ? err.response.data != null
            ? err.response.data.message != null
              ? err.response.data.message
              : err.message
            : err.message
          : err.message,
      color: "red",
    });
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
    return;
  });
  if (res.status == 200) {
    return res.data;
  } else {
    showNotification({
      title: "ERROR",
      message: res.data.message,
      color: "red",
    });
    return [];
  }
}

async function getMenteeTasksF() {
  const res = await getMenteeTasks().catch((err) => {
    showNotification({
      title: "ERROR",
      message:
        err.response != null
          ? err.response.data != null
            ? err.response.data.message != null
              ? err.response.data.message
              : err.message
            : err.message
          : err.message,
      color: "red",
    });
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
    return;
  });
  if (res.status == 200) {
    return res.data;
  } else {
    showNotification({
      title: "ERROR",
      message: res.data.message,
      color: "red",
    });
    return [];
  }
}

function AccordionExample() {
  const [load, setLoad] = useState(true);
  const [Tasks, setTasks] = useState([]);

  useEffect(() => {
    if (type == "MENTEE" || type == "MENTOR") {
      getMenteeTasksF().then((res) => {
        setLoad(false);
        setTasks(res.menteeTasks);
      });
    } else {
      getAdminTasksF().then((res) => {
        //console.log(res);
        setLoad(false);
        setTasks(res.domains);
      });
    }
  }, []);
  return (
    <>
      <LoadingOverlay visible={load}></LoadingOverlay>
      <Accordion transitionDuration={500}>
        {Tasks.map((domain) => {
          if (domain.Tasks && domain.Tasks.length > 0) {
            return (
              <Accordion.Item
                label={<AccordionLabel label={domain.name} />}
                style={{ fontSize: "15px" }}
                key={domain.name}
              >
                <Grid grow columns={9} gutter="sm">
                  {domain.Tasks.map((task) => {
                    task.domainName = domain.name;
                    return (
                      <Grid.Col span={3} key={task.taskId}>
                        <CardExample task={task} />
                      </Grid.Col>
                    );
                  })}
                </Grid>
              </Accordion.Item>
            );
          }
        })}
      </Accordion>
    </>
  );
}

export default AccordionExample;
